import { hasOwnProperty } from '../utils/objects';

export const INJECT_REDUCER = 'INJECT_REDUCER';
export const INJECT_SAGAS = 'INJECT_SAGAS';

export const registryMiddleware = registry => () => next => action => {
  // eslint-disable-line
  if (hasOwnProperty(action, INJECT_REDUCER)) {
    const { reducers } = action[INJECT_REDUCER];

    if (reducers) {
      registry.injectReducers(reducers);
    }
    return;
  }
  if (hasOwnProperty(action, INJECT_SAGAS)) {
    const { sagas } = action[INJECT_SAGAS];
    if (sagas) {
      registry.injectSagas(sagas);
    }
    return;
  }
  return next(action); // eslint-disable-line consistent-return
};
